import React from 'react'
import {Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {colors} from '@/constants'
import {getTicketStatusKind, TicketStatusKind} from '@/helpers/supportTickets'

const STATUS_VIEW: Record<
  TicketStatusKind,
  {textKey: string; color: string; background: string}
> = {
  open: {textKey: '1744', color: colors.brown, background: colors.yellow},
  answered: {textKey: '1751', color: colors.brown, background: colors.orange},
  closed: {textKey: '1745', color: colors.gray, background: colors.brown2},
}

const StatusBadge = ({status}: {status: string}) => {
  const {t} = useTranslation()
  const view = STATUS_VIEW[getTicketStatusKind(status)]

  return (
    <Typography
      fontSize="12px"
      padding="3px 12px"
      borderRadius="8px"
      flex="none"
      color={view.color}
      sx={{background: view.background}}>
      {t(view.textKey)}
    </Typography>
  )
}

export default StatusBadge
